import { collections } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full bg-background-50 py-14 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="精选合集 · 内容大全"
          title="按主题整理好的合集，喜欢就一口气看完"
          desc="把同类内容打包成合集，省去一条条翻找的麻烦。每个合集都标注了作品数量与主题方向，挑一个方向就能连续刷下去。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.name}合集封面 · ${item.theme}类小视频`}
                  title={`${item.name} · 小视频精选合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 font-label text-xs font-semibold text-primary-700">
                  {item.theme}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-3 py-1 font-label text-xs font-medium text-background-50">
                  <i className="ri-stack-line"></i>
                  {item.count}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}